import ReactSlider from 'react-slider'

import classNames from 'classnames'

import { numberWithCommas } from '~/utils/formatCurrency'

import styles from './RangeSlider.module.css'

export interface RangeSliderProps {
  testID?: string
  min?: number
  max?: number
  step?: number
  value?: number[] | number | any
  handleChange: (e: any) => void
  useDualSlider?: boolean
  smallHeight?: boolean
}

export default function RangeSlider({
  testID,
  min = 0,
  max = 100,
  step = 10000,
  handleChange,
  value,
  useDualSlider = true,
  smallHeight = false,
}: RangeSliderProps) {
  const defaultValue = useDualSlider
    ? value && value?.length > 0
      ? value
      : [min, max]
    : typeof value === 'number'
      ? value
      : min

  return (
    <div className={styles.base} data-testid={testID}>
      <ReactSlider
        className={classNames(
          styles.horizontalSlider,
          smallHeight && styles.smallHeight
        )}
        thumbClassName={styles.sliderThumb}
        trackClassName={styles.sliderTrack}
        value={defaultValue}
        onAfterChange={handleChange}
        ariaLabel={useDualSlider ? ['Lower thumb', 'Upper thumb'] : 'Thumb'}
        ariaValuetext={(state: any) => `Thumb value ${state.valueNow}`}
        renderThumb={(props: any, state: any) => {
          return (
            <div {...props}>
              <div className={styles.thumbText}>
                {useDualSlider ? (
                  <>&pound;{numberWithCommas(state.valueNow)}</>
                ) : (
                  ''
                )}
              </div>
            </div>
          )
        }}
        min={min}
        max={max}
        pearling
        step={step}
      />
    </div>
  )
}
